import React, { useCallback, useEffect, useRef, useState } from 'react';
import Context from '../Context';

// Mounted only in the dev log viewer. No timers or global per-admin requests.
export default function AuditAlerts() {
  const { callApi } = Context();
  const [alerts,setAlerts] = useState([]), [error,setError] = useState(''), [loading,setLoading] = useState(false);
  const mounted = useRef(true), running = useRef(false), api = useRef(callApi);
  api.current=callApi;
  const load = useCallback(async () => {
    if (running.current) return;
    running.current=true;setLoading(true);setError('');
    try {
      const result = await api.current('logs-getAuditAlerts', {});
      if (!mounted.current) return;
      if (!result?.success) throw Error('load');
      setAlerts(result.alerts || []);
    } catch { if (mounted.current) setError('โหลด alerts ไม่สำเร็จ กดรีเฟรชเพื่อลองอีกครั้ง'); }
    finally { running.current=false;if(mounted.current)setLoading(false); }
  }, []);
  useEffect(() => { mounted.current=true;load();return () => {mounted.current=false;}; }, [load]);
  return <section className="mb-4 rounded-xl border border-slate-200 bg-white p-4 text-xs text-slate-600">
    <div className="flex items-center justify-between gap-3"><span>Security alerts · ล่าสุดไม่เกิน 20 รายการใน 24 ชั่วโมง · ไม่มี polling</span><button disabled={loading} onClick={load} className="rounded-lg border px-3 py-2 disabled:opacity-50">รีเฟรช alerts</button></div>
    {error && <p role="alert" className="mt-2 text-rose-700">{error}</p>}
    {!loading && !error && !alerts.length && <p className="mt-2 text-slate-400">ไม่พบ alerts ในช่วงนี้</p>}
    {alerts.map(alert => <div key={alert.id} className="mt-2 break-all font-mono"><p>{new Date(alert.occurredAt).toLocaleString('th-TH',{timeZone:'Asia/Bangkok'})} · {alert.kind} · actorId: {alert.actorId || 'unverified'}</p><details className="mt-1 text-slate-400"><summary className="cursor-pointer">รหัสอ้างอิง</summary><p>eventId: {alert.eventId || '—'} · requestId: {alert.requestId || '—'}</p></details></div>)}
  </section>;
}
